import React, { useCallback } from "react";

import { faChevronDown, faTextSize } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import { Editor } from "slate";
import { useSlate } from "slate-react";

import { stopEvents } from "@mapmycustomers/shared/util/browser";

import { useConfigProvider } from "../../../../ConfigProvider";
import Dropdown from "../../../../Dropdown";
import TextSize from "../../../../type/slate/TextSize";
import commonStyles from "../../EmailBody.module.scss";
import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";
import styles from "./Toolbar.module.scss";

const TextSizeSelector = () => {
  const editor = useSlate();
  const configProvider = useConfigProvider();

  const handleToggleTextSize = useCallback(
    (size: TextSize) => {
      Editor.addMark(editor, "size", size);
    },
    [editor]
  );

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: TextSize.SMALL,
            label: (
              <span className={commonStyles.sizeSmall}>
                {configProvider.formatMessage("ui.emailBody.toolbar.small")}
              </span>
            ),
          },
          {
            key: TextSize.MEDIUM,
            label: (
              <span className={commonStyles.sizeMedium}>
                {configProvider.formatMessage("ui.emailBody.toolbar.medium")}
              </span>
            ),
          },
          {
            key: TextSize.LARGE,
            label: (
              <span className={commonStyles.sizeLarge}>
                {configProvider.formatMessage("ui.emailBody.toolbar.large")}
              </span>
            ),
          },
        ],
        onClick: (e) => handleToggleTextSize(e.key as TextSize),
        onMouseDown: stopEvents,
      }}
      placement="top"
    >
      <ToggleButton>
        <ActionTooltipWrapper placement="bottom" translationString="ui.emailBody.toolbar.size">
          <Row align="middle" className={styles.toggleButtonContent} gutter={4}>
            <Col>
              <FontAwesomeIcon icon={faTextSize} />
            </Col>
            <Col>
              <FontAwesomeIcon className={styles.dropDownChevron} icon={faChevronDown} size="xs" />
            </Col>
          </Row>
        </ActionTooltipWrapper>
      </ToggleButton>
    </Dropdown>
  );
};

export default TextSizeSelector;
